/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SmallAttachment
 */
export interface SmallAttachment {
    /**
     * 
     * @type {number}
     * @memberof SmallAttachment
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof SmallAttachment
     */
    readonly type?: SmallAttachmentTypeEnum;
}

export function SmallAttachmentFromJSON(json: any): SmallAttachment {
    return SmallAttachmentFromJSONTyped(json, false);
}

export function SmallAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmallAttachment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function SmallAttachmentToJSON(value?: SmallAttachment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

/**
* @export
* @enum {string}
*/
export enum SmallAttachmentTypeEnum {
    Unknown = 'unknown',
    PassportFront = 'passport_front',
    PassportReverse = 'passport_reverse',
    Inn = 'inn',
    Snils = 'snils',
    Converted = 'converted',
    BirthCertificate = 'birth_certificate',
    ChildRepresentativeApproval = 'child_representative_approval',
    MarriageContract = 'marriage_contract',
    SpousesNotarialConsent = 'spouses_notarial_consent',
    PassportOriginal = 'passport_original',
    Apostille = 'apostille',
    MaternalCapitalCertificate = 'maternal_capital_certificate',
    MaternalCapitalCertificateBalance = 'maternal_capital_certificate_balance',
    MortgageCertificate = 'mortgage_certificate',
    SubsidyCertificate = 'subsidy_certificate'
}


